// extracted by mini-css-extract-plugin
export default {"container":"Coupons_container__8KqVb","couponsContainer":"Coupons_couponsContainer__N8Xql","header":"Coupons_header__YBi8A"};